import WhatsappSender from './WhatsappSender';

export { WhatsappSender };



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsAppSender/components/index.js